import { define } from '@rlean/core';

const FormTemplate = define('formTemplate', {
  initialState: {},
  nullableParams: true,
  getURL: '/FormTemplate',
  postURL: '/FormTemplate',
});

export default FormTemplate;
